/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Sync API
 * An API for notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    NotificationResponse,
    NotificationResponseFromJSON,
    NotificationResponseToJSON,
} from '../models';

export interface TriggerBookingNotificationsRequest {
    userId: string;
}

/**
 * 
 */
export class NotificationApi extends runtime.BaseAPI {

    /**
     * trigger notifications for bookings.
     * trigger notifications for bookings.
     */
    async triggerBookingNotificationsRaw(requestParameters: TriggerBookingNotificationsRequest): Promise<runtime.ApiResponse<NotificationResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling triggerBookingNotifications.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/notification/bookings/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationResponseFromJSON(jsonValue));
    }

    /**
     * trigger notifications for bookings.
     * trigger notifications for bookings.
     */
    async triggerBookingNotifications(requestParameters: TriggerBookingNotificationsRequest): Promise<NotificationResponse> {
        const response = await this.triggerBookingNotificationsRaw(requestParameters);
        return await response.value();
    }

}
